import { State } from './types';

export const vectorizerStoreSelector = {
  loading: (state: State) => state.loading,
  vectorizing: (state: State) => state.vectorizing,
  image: (state: State) => state.image,
  displayedImage: (state: State) => state.displayedImage,
  result: (state: State) => state.result,
  fileName: (state: State) => state.fileName,
  vectorized: (state: State) => state.vectorized,
  actions: (state: State) => state.actions,
};
